import axios from "axios";
import { Fragment, useEffect, useState } from "react"
import Frames from "./Frames";
import "./Home.css";
import "./card.css"
import Metadata from "./Metadata";
import CartSlice from "../store/Cartslice";
import Frameslice from "../store/Frameslice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";



const Homeframes = () => {
    const dispatch = useDispatch();
    const framevalue = useSelector((store) => {
        return store.frame.products

    })
    const loader = useSelector((store) => {
        return store.frame.loading

    })
    useEffect(() => {
        dispatch(Frameslice.actions.productsrequest())
        axios.get("https://retoolapi.dev/vy8MGm/Frames")
            .then(response => dispatch(Frameslice.actions.productssuccess(response.data)))
            .catch(err => console.log(err))


    }, []);
    return (
        <Fragment>
            {loader ? <Loader> </Loader> :
                <div className="frames container">

                    <Metadata title={"Frames-Leegifts"}> </Metadata>
                    {framevalue.map((ele, idx) => {
                        return (
                            <Frames key={idx} img={ele.img} title={ele.title} price={ele.price} id={ele.id} num={ele.num}> </Frames>
                        )
                    })}


                </div>}

        </Fragment>


    )


}
export default Homeframes;